/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FreeInputs */

const id_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ms_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percuma`)
};

const da_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const de_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const en_us2_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_es2_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const es_mx2_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fil_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre`)
};

const fr_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const hu_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes`)
};

const nl_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const no_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe`)
};

const pt_br2_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const pt_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ro_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const fi_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const sv_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const vi_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miễn phí`)
};

const tr_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const cs_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdarma`)
};

const bg_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатно`)
};

const ru_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const uk_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовно`)
};

const ar_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني`)
};

const hi_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त`)
};

const th_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const ja_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_cn2_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

const zh_hant1_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費`)
};

const ko_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Common_FreeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const common_free = /** @type {((inputs?: Common_FreeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FreeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_free(inputs)
	if (locale === "ms") return ms_common_free(inputs)
	if (locale === "da") return da_common_free(inputs)
	if (locale === "de") return de_common_free(inputs)
	if (locale === "en-US") return en_us2_common_free(inputs)
	if (locale === "es-ES") return es_es2_common_free(inputs)
	if (locale === "es-MX") return es_mx2_common_free(inputs)
	if (locale === "fil") return fil_common_free(inputs)
	if (locale === "fr") return fr_common_free(inputs)
	if (locale === "it") return it_common_free(inputs)
	if (locale === "hu") return hu_common_free(inputs)
	if (locale === "nl") return nl_common_free(inputs)
	if (locale === "no") return no_common_free(inputs)
	if (locale === "pl") return pl_common_free(inputs)
	if (locale === "pt-BR") return pt_br2_common_free(inputs)
	if (locale === "pt") return pt_common_free(inputs)
	if (locale === "ro") return ro_common_free(inputs)
	if (locale === "fi") return fi_common_free(inputs)
	if (locale === "sv") return sv_common_free(inputs)
	if (locale === "vi") return vi_common_free(inputs)
	if (locale === "tr") return tr_common_free(inputs)
	if (locale === "cs") return cs_common_free(inputs)
	if (locale === "bg") return bg_common_free(inputs)
	if (locale === "ru") return ru_common_free(inputs)
	if (locale === "uk") return uk_common_free(inputs)
	if (locale === "ar") return ar_common_free(inputs)
	if (locale === "hi") return hi_common_free(inputs)
	if (locale === "th") return th_common_free(inputs)
	if (locale === "ja") return ja_common_free(inputs)
	if (locale === "zh-CN") return zh_cn2_common_free(inputs)
	if (locale === "zh-Hant") return zh_hant1_common_free(inputs)
	return ko_common_free(inputs)
});
export { common_free as "common.free" }